// extracted by mini-css-extract-plugin
module.exports = {"Menu":"_3yNfzhcwU0Z6IAzQ48ZxPK"};